import { render, staticRenderFns } from "./WizardNextButton.vue?vue&type=template&id=1858468b"
import script from "./WizardNextButton.vue?vue&type=script&lang=js"
export * from "./WizardNextButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports